import React from "react";
import { Navigate } from "react-router-dom";

const AuthenticatedRoute = ({ children, redirectTo }) => {
  const auth = JSON.parse(localStorage.getItem("userDetail"));

  const isAuthenticated = auth && auth.token;

  return isAuthenticated ? <Navigate to={redirectTo} /> : children;
};

export default AuthenticatedRoute;